import { ReportSummaryMapping } from '../../../../components/report/redesigned';
import { ReportSummaryInterface } from '../../../common/ReportSummaryInterface';

export interface BuyerInvoicesSummary extends ReportSummaryInterface {
  invoices: number;
  grossAmount: number;
  buyerAmount: number;
  paymentProcessorFees: number;
  transactionTaxAmount: number;
}

export const buyerInvoicesSummaryMapping = [
  { id: 'invoices', label: 'Invoices Count', formatter: 'number' },
  { id: 'buyerAmount', label: 'Base Charges', formatter: 'currency' },
  { id: 'paymentProcessorFees', label: 'Processor Fees', formatter: 'currency' },
  { id: 'transactionTaxAmount', label: 'Taxes', formatter: 'currency' },
  { id: 'grossAmount', label: 'Total Charges', formatter: 'currency' },
] satisfies ReportSummaryMapping[];